import { addKr } from './helper';
import React from 'react';

export const getPrices = (item, sectionClass, listPriceClass, sublineClass) => {
  return (
    <>
      <div className={`d-flex ${sectionClass}`}>
        <div className="flex-grow-1">{item.name}</div>
        {item.listPrice && <span className={listPriceClass}>{addKr(item.listPrice)}</span>}
        {addKr(item.price)}
      </div>
      {item.priceSublines &&
        item.priceSublines.map((sublines) => <div className={sublineClass}>{sublines}</div>)}
    </>
  );
};
